import { DataAnalyticsService } from './../../services/data-analytics.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import * as c3 from 'c3';
import { MatDialog } from '@angular/material/dialog';
import { DaRmPmPopupViewComponent } from '../da-rm-pm-popup-view/da-rm-pm-popup-view.component';
import { RmPmCostContibutionResponse } from '../../models/factory-summary';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-da-rm-pm',
  templateUrl: './da-rm-pm.component.html',
  styleUrls: ['./da-rm-pm.component.scss']
})
export class DaRmPmComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() factorySummary: any;
  @Input() levelType: string;
  @ViewChild('graphDiv') graphDiv: ElementRef;
  chart: any;
  /* istanbul ignore next */
  rmValue = 0;
  pmValue = 0;
  isLoading = false;
  public message = '';
  rmPmResponseData: RmPmCostContibutionResponse;

  getRMPMSubscription: Subscription;
  /* istanbul ignore next */
  constructor(
    private daService: DataAnalyticsService,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) { }
  /* istanbul ignore next */
  ngOnInit() {

  }
  /* istanbul ignore next */
  ngAfterViewInit(): void {
    /* istanbul ignore next */
    setTimeout(() => {
      this.drawGraph();
    }, 0);
  }
  /* istanbul ignore next */
  drawGraph() {
    this.isLoading = true;
    /* istanbul ignore next */
    this.chart = c3.generate({
      bindto: this.graphDiv.nativeElement,
      size: {
        height: 200,
        width: 200
      },
      data: {
        columns: [
          ['rm', 0],
          ['pm', 0],
        ],
        type: 'donut',
        colors: {
          rm: '#1B4972',
          pm: '#00A9E0'
        },
        /* istanbul ignore next */
        onclick: (d, element) => {
          this.popupGraph(d.id);
        },
      },
      donut: {
        title: '100%',
        width: 20,
        label: {
          /* istanbul ignore next */
          format(value, ratio, id) {
            return '';
          }
        }
      },
      legend: {
        hide: true
      }
    });
    /* istanbul ignore next */
    this.message = 'Loading...';
    const param = {
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      FactoryId: this.factorySummary.factoryId,
      Level: 'factory',
    };
    /* istanbul ignore next */
    if (this.levelType === 'line') {
      param.Level = 'line';
      const lineId = 'LineId';
      this.route.queryParams.subscribe(paramsList => {
        param[lineId] = paramsList.LineId;
      });

    }
    /* istanbul ignore next */
    this.getRMPMSubscription = this.daService.getRMPM(param)
      /* istanbul ignore next */
      .subscribe((res: RmPmCostContibutionResponse) => {
        if (res && res.rmPmCostConsumption && res.rmPmCostConsumption.length > 0) {
          this.rmPmResponseData = res;
          const rm = res.rmPmCostConsumption.find(r => {
            if (r.materialType === 'RM') { return r.wasteCostEuro; }
          });
          const pm = res.rmPmCostConsumption.find(r => {
            if (r.materialType === 'PM') { return r.wasteCostEuro; }
          });
          if (rm != undefined && pm != undefined) {
            var rmpmTotal = rm.wasteCostEuro + pm.wasteCostEuro;
            this.rmValue = Number(((rm.wasteCostEuro / Math.abs(rmpmTotal)) * 100).toFixed(2));
            this.pmValue = Number(((pm.wasteCostEuro / Math.abs(rmpmTotal)) * 100).toFixed(2));
          } else if (rm != undefined && rm.wasteCostEuro) {
            var rmpmTotal = rm.wasteCostEuro;
            this.rmValue = Number(((rm.wasteCostEuro / Math.abs(rmpmTotal)) * 100).toFixed(2));
          } else if (pm != undefined && pm.wasteCostEuro) {
            var rmpmTotal = pm.wasteCostEuro;
            this.pmValue = Number(((pm.wasteCostEuro / Math.abs(rmpmTotal)) * 100).toFixed(2));
          }

          this.chart.load({
            columns: [
              ['rm', this.rmValue],
              ['pm', this.pmValue],
            ]
          });
          this.isLoading = false;
        } else {
          this.rmValue = 0;
          this.pmValue = 0;
          this.message = 'Data not available.';
          if (this.chart) {
            this.chart.destroy();
          }
        }
      });
  }
  /* istanbul ignore next */
  onChangeDate(start, end) {
    this.factorySummary.fromDate = start;
    this.factorySummary.toDate = end;
    this.drawGraph();
  }
  /* istanbul ignore next */
  popupGraph(type: string) {
    /* istanbul ignore next */
    this.dialog.open(DaRmPmPopupViewComponent, {
      // panelClass: 'popup-dialog-container',
      width: '840px',
      data: {
        selectedType: type,
        rmValue: this.rmValue,
        pmValue: this.pmValue,
        responseData: this.rmPmResponseData,
        level: this.levelType
      }
    });
  }
  /* istanbul ignore next */
  ngOnDestroy(): void {
    if (this.getRMPMSubscription) {
      this.getRMPMSubscription.unsubscribe();
    }
  }
}
